import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ComponentStatus, StateComponent } from '../../../../../../../common/components/state/state.component';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { CompetitionGroupCommonService } from '../../services/competition-group-common.service';
import { ICompetitionGroupModel } from '../../../../../../../common/apis/competition-group/model/competitoin-group.model';
import { LoadingContainerComponent } from '../../../../../../../common/components/loading-container/loading-container.component';
import { MatIcon } from '@angular/material/icon';
import { MatTabLink, MatTabNav, MatTabNavPanel } from '@angular/material/tabs';
import { BarBottomRowComponent } from '../../../../../../../common/components/main/app-bar/bar-bottom-row/bar-bottom-row.component';

@Component({
  selector: 'oo-comp-group-wrapper',
  templateUrl: './comp-group-wrapper.component.html',
  styleUrls: ['./comp-group-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CompetitionGroupCommonService],
  imports: [BarBottomRowComponent, MatTabNav, MatTabLink, RouterLink, MatIcon, LoadingContainerComponent, MatTabNavPanel, RouterOutlet],
})
export class CompGroupWrapperComponent extends StateComponent<CompGroupWrapperComponentState> implements OnInit {

  state: CompGroupWrapperComponentState = {
    status: 'ready',
    currentRoute: null,
    compGroup: null!,
  };
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly tournamentCommonService = inject(CompetitionGroupCommonService);

  ngOnInit(): void {
    this.setCurrentRoute();
    this.fetchData();
  }

  updateNavTo(route: Routes): void {
    this.updateState({ currentRoute: route });
  }

  private setCurrentRoute(): void {
    if (this.doesPathIncludes('standings')) {
      this.updateState({ currentRoute: 'standings' });
    } else if (this.doesPathIncludes('forms')) {
      this.updateState({ currentRoute: 'forms' });
    } else if (this.doesPathIncludes('participants')) {
      this.updateState({ currentRoute: 'participants' });
    } else if (this.doesPathIncludes('configurations')) {
      this.updateState({ currentRoute: 'configurations' });
    }
  }

  private doesPathIncludes(str: Routes): boolean {
    return Boolean(this.router.url.includes(str as string));
  }

  private fetchData(): void {
    this.updateStatus('loading');
    this.tournamentCommonService.fetchUserCompGroups()
      .then(() => this.tournamentCommonService
        .getCompGroupInfo(this.route.snapshot.paramMap.get('tournamentId') as string))
      .then((compGroup) => {
        this.updateState({
          status: 'ready',
          compGroup,
        });
      })
      .catch((e: Error) => {
        console.error(e);
        this.updateStatus('error');
      });
  }
}

interface CompGroupWrapperComponentState {
  status: ComponentStatus;
  currentRoute: Routes;
  compGroup: ICompetitionGroupModel;
}

type Routes = null | 'standings' | 'forms' | 'participants' | 'configurations';
